import { createSelector } from 'reselect';

const substate = (state) => state.CRMWebConfiguration;

export const selectCRMWebConfiguration = () =>
    createSelector(substate, (contextState) => contextState.CRMWebConfiguration);
